import { format } from "date-fns";
import { es } from "date-fns/locale"; // Importar el locale español
import style from "./ModalScores.module.css";
import { Bar } from "react-chartjs-2";
import { useState } from "react";
import axios from "axios";
import { URL } from "../../../../link";
import { useEffect } from "react";
import VideoPlayer from "../../../../utils/VideoPlayer";
import Comentarios from "../../../../sharedComponents/Comentarios/Comentarios";
import AgregarComentario from "../../../../sharedComponents/AgregarComentario/AgregarComentario";

const ModalScore = ({ user, setDetallesBool, dateSelected }) => {
  const userLocal = JSON.parse(localStorage.getItem("dataUser"));
  const [scoreMetricas, setScoreMetricas] = useState({});
  const [fechaScoreUpdate, setFechaScoreUpdate] = useState("");
  const [sinScore, setSinScore] = useState(true);
  const [diasSinScore, setDiasSinScore] = useState(0);
  const [fechaHoy, setFechaHoy] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isMounted, setIsMounted] = useState(true);
  const [comentario, setComentario] = useState("");
  const [mostrarVideo, setMostrarVideo] = useState(false);
  const [valor, setValor] = useState(0);
  const [comentarioEstrellas, setComentarioEstrellas] = useState("");
  const [displayNone, setDisplayNone] = useState(false);
  const [error, setError] = useState("");

  console.log(userLocal);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  const prepararDatosGrafico = (scoreTotal) => {
    return {
      labels: ["BSD Score"],
      datasets: [
        {
          label: "Entrenamiento",
          data: [scoreTotal * 0.25], // 25%
          backgroundColor: "rgba(76, 60, 207, 1)",
          borderColor: "rgba(76, 60, 207, 1)",
          borderWidth: 1,
        },
        {
          label: "Constancia",
          data: [scoreTotal * 0.1], // 10%
          backgroundColor: "rgba(255, 193, 7, 1)",
          borderColor: "rgba(255, 193, 7, 1)",
          borderWidth: 1,
        },
        {
          label: "Goles",
          data: [scoreTotal * 0.05], // 5%
          backgroundColor: "rgba(40, 167, 69, 1)",
          borderColor: "rgba(40, 167, 69, 1)",
          borderWidth: 1,
        },
        {
          label: "Evaluación Personal",
          data: [scoreTotal * 0.2], // 20%
          backgroundColor: "rgba(220, 53, 69, 1)",
          borderColor: "rgba(220, 53, 69, 1)",
          borderWidth: 1,
        },
        {
          label: "Velocidad",
          data: [scoreTotal * 0.1], // 10%
          backgroundColor: "rgba(23, 162, 184, 1)",
          borderColor: "rgba(23, 162, 184, 1)",
          borderWidth: 1,
        },
        {
          label: "Resistencia",
          data: [scoreTotal * 0.1], // 10%
          backgroundColor: "rgba(111, 66, 193, 1)",
          borderColor: "rgba(111, 66, 193, 1)",
          borderWidth: 1,
        },
        {
          label: "Salto",
          data: [scoreTotal * 0.1], // 10%
          backgroundColor: "rgba(253, 126, 20, 1)",
          borderColor: "rgba(253, 126, 20, 1)",
          borderWidth: 1,
        },
        {
          label: "Fuerza",
          data: [scoreTotal * 0.1], // 10%
          backgroundColor: "rgba(32, 201, 151, 1)",
          borderColor: "rgba(32, 201, 151, 1)",
          borderWidth: 1,
        },
      ],
    };
  };

  const opcionesGrafico = {
    indexAxis: "x", // Cambiado a 'x' para orientación vertical
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        max: 100,
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 12,
          padding: 10,
          font: {
            size: 11, // Reducido el tamaño de la fuente para mejor ajuste
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.raw.toFixed(1)}%`;
          },
        },
      },
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  const transformarFecha = (fechaString) => {
    try {
      const fechaLimpia = fechaString.replace("Fecha: ", "");
      const [dia, mes, año] = fechaLimpia.split("/");

      // Crear el string de fecha en formato ISO
      const fechaISO = `20${año}-${mes.padStart(2, "0")}-${dia.padStart(
        2,
        "0"
      )}T12:00:00`;

      // Crear la fecha usando el string ISO
      const fecha = new Date(fechaISO);

      return fecha;
    } catch (error) {
      console.error("Error al transformar la fecha:", error);
      return new Date();
    }
  };

  const getScoreMetricas = async () => {
    setIsLoading(true);
    const data = {
      userId: user.id,
      fecha: format(fechaHoy, "yyyy-MM-dd"),
    };
    try {
      const response = await axios.post(`${URL}/score/metrics`, data);
      if (isMounted) {
        setScoreMetricas(response.data);
      }
    } catch (error) {
      if (isMounted) {
        setScoreMetricas({});
        console.error("Error al obtener métricas:", error);
      }
    } finally {
      if (isMounted) {
        setIsLoading(false);
      }
    }
  };

  const fechaHoyFormateada = fechaHoy
    ? format(fechaHoy, "EEEE, dd 'de' MMMM 'de' yyyy", {
        locale: es,
      })
    : "";

  const fechaFormateadaCapitalizada = fechaHoyFormateada
    ? fechaHoyFormateada.charAt(0).toUpperCase() + fechaHoyFormateada.slice(1)
    : "";

  useEffect(() => {
    if (dateSelected) {
      const hoy = transformarFecha(dateSelected);
      if (isMounted) {
        setFechaHoy(hoy);
      }
    } else {
      const hoy = new Date();
      if (isMounted) {
        setFechaHoy(hoy);
      }
    }
    return () => {
      // Cleanup function
      if (isMounted) {
        setFechaHoy("");
      }
    };
  }, [dateSelected]);

  useEffect(() => {
    if (fechaHoy) {
      getScoreMetricas();
    }
    return () => {
      // Cleanup function
      setScoreMetricas({});
      setIsLoading(true);
    };
  }, [fechaHoy]);

  const getDiasSinScore = () => {
    // Fecha por defecto: 1 de enero de 2025
    const fechaDefault = new Date("2025-01-01");

    // Obtener la fecha de actualización del score, si existe
    const fechaUpdate = user.scores?.[0]?.updatedAt
      ? new Date(user.scores[0].updatedAt)
      : fechaDefault;

    const fechaHoy = new Date();
    const diferencia = fechaHoy - fechaUpdate;
    const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
    setDiasSinScore(dias);
  };

  useEffect(() => {
    if (user.scores?.[0]?.updatedAt) {
      const fechaUpdate = new Date(user.scores[0].updatedAt);
      const fechaFormateada = format(
        fechaUpdate,
        "EEEE, dd 'de' MMMM 'de' yyyy",
        { locale: es }
      );
      setFechaScoreUpdate(
        fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1)
      );
      setSinScore(false);
    } else {
      setSinScore(true);
      setFechaScoreUpdate(
        format(new Date("2025-01-01"), "EEEE, dd 'de' MMMM 'de' yyyy", {
          locale: es,
        })
      );
    }
    getDiasSinScore();
  }, [user]);

  const calcularPorcentaje = (dias) => {
    const porcentaje = (dias * 0.3).toFixed(1);
    return porcentaje;
  };

  const agregarComentario = async () => {
    const data = {
      id: scoreMetricas.score.id,
      comentario: comentario,
    };

    try {
      const response = await axios.post(`${URL}/score/addComentario`, data);
      await getScoreMetricas();
    } catch (error) {
      console.error("Error al agregar comentario:", error);
    }
  };

  const darEstrellas = async () => {
    const data = {
      userId: userLocal.id,
      entrenamientoId: scoreMetricas.entrenamiento?.id || null,
      comentario: comentarioEstrellas,
      valor: valor,
    };
    try {
      if (scoreMetricas.entrenamiento !== null) {
        await axios.post(`${URL}/entrenamiento/estrella`, data);
        await getScoreMetricas();
        setComentarioEstrellas("");
        setValor(0);
        setError("");
      }
      console.log("No es posible dar estrellas");
    } catch (error) {
      console.error("Error al dar estrellas:", error);
      setError(error.response.data.message);
    }
  };

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError("");
      }, 3000);
    }
  }, [error]);

  useEffect(() => {
    if (user.scores[0]?.updatedAt) {
      const fechaUpdate = new Date(user.scores[0].updatedAt);
      const fechaFormateada = format(
        fechaUpdate,
        "EEEE, dd 'de' MMMM 'de' yyyy",
        { locale: es }
      );
      setFechaScoreUpdate(
        fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1)
      );
      setSinScore(false);
    } else {
      setSinScore(true);
    }
    getDiasSinScore();
  }, [user]);

  return (
    <div className={style.conteiner}>
      <div className={style.modalContent}>
        {isLoading ? (
          <div className={style.loading}>Cargando...</div>
        ) : (
          <div className={style.conteiner}>
            <span
              className={style.titleMAnd}
              onClick={() => setDetallesBool(false)}
            >
              cerrar
            </span>
            <div className={style.modalContent}>
              <div className={`${style.conSubGrafico} ${
                          displayNone ? style.displayNone : ""
                        }`}>
                <div className={style.contTitle}>
                  <h2 className={style.title}>BSD SCORE</h2>
                </div>
                <div className={style.grafica}>
                  <Bar
                    data={prepararDatosGrafico(user.scores[0]?.valor || 0)}
                    options={opcionesGrafico}
                    height={300}
                  />
                </div>
              </div>
              <div className={style.contHistorico}>
                <span
                  className={style.txtCerrar}
                  onClick={() => setDetallesBool(false)}
                >
                  X
                </span>
                <div className={style.cont}>
                  <div className={style.contSubHistorico}>
                    <span className={style.txtFecha}>
                      {fechaFormateadaCapitalizada}
                    </span>
                    <div className={style.contAnalisis}>
                      <span className={style.txtAnalisis}>Analisis BSD</span>
                      <span className={style.txtAnalisis}>
                        SCORE: {user.scores?.[0]?.valor ?? 0}
                      </span>
                    </div>
                    <div className={style.contResumen}>
                      <div className={style.txtResumen}>
                        Score actualizado el {fechaScoreUpdate}.
                      </div>
                      <span
                        className={style.verComentarios}
                        onClick={() => setDisplayNone(!displayNone)}
                      >
                        {displayNone ? "Ver analisis" : "Ver comentarios"}
                      </span>
                      {diasSinScore > 0 && (
                        <div className={style.txtResumen}>
                          {diasSinScore} días sin actividad registrada.
                          Constancia disminuida en un{" "}
                          {calcularPorcentaje(diasSinScore)}%
                        </div>
                      )}
                      
                      <div className={`${style.contMetricas} ${
                          displayNone ? style.displayNone : ""
                        }`}>
                        {scoreMetricas.metricas !== null ? (
                          <div className={style.metricas}>
                            <div className={style.contEntrenamiento}>
                        {scoreMetricas.entrenamiento === null ? (
                          <div className={style.txtResumen}>
                            No hay entrenamientos registrados de este dia
                          </div>
                        ) : (
                          <div className={style.txtResumen}>
                            Registro {scoreMetricas.entrenamiento?.tipo} de{" "}
                            {scoreMetricas.entrenamiento?.tiempo} minutos
                            {scoreMetricas.entrenamiento?.tipo === "Partido" &&
                              scoreMetricas.entrenamiento?.goles > 0 &&
                              `, y ha registrado ${scoreMetricas.entrenamiento?.goles} goles`}
                            {scoreMetricas.entrenamiento?.video && (
                              <div>
                                y se subió un video
                                <p
                                  className={style.txtVideo}
                                  onClick={() => setMostrarVideo(!mostrarVideo)}
                                >
                                  {mostrarVideo
                                    ? "ocultar video"
                                    : "mostrar video"}
                                </p>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                            {scoreMetricas.metricas?.velocidad && (
                              <div className={style.txtResumen}>
                                Se registró la métrica{" "}
                                {scoreMetricas.metricas?.velocidad.nombre}:
                                Recorre 50 metros en{" "}
                                {scoreMetricas.metricas?.velocidad.valor}{" "}
                                segundos.
                              </div>
                            )}
                            {scoreMetricas.metricas?.fuerza && (
                              <div className={style.txtResumen}>
                                Se registró la métrica{" "}
                                {scoreMetricas.metricas?.fuerza.nombre}: Levanta{" "}
                                {scoreMetricas.metricas?.fuerza.valor} kg. en
                                piernas.
                              </div>
                            )}
                            {scoreMetricas.metricas?.salto && (
                              <div className={style.txtResumen}>
                                Se registró la métrica{" "}
                                {scoreMetricas.metricas?.salto.nombre}: Salta{" "}
                                {scoreMetricas.metricas?.salto.valor} cm.
                              </div>
                            )}
                            {scoreMetricas.metricas?.resistencia && (
                              <div className={style.txtResumen}>
                                Se registró la métrica{" "}
                                {scoreMetricas.metricas?.resistencia.nombre}:
                                Recorre 3 km en{" "}
                                {scoreMetricas.metricas?.resistencia.valor}{" "}
                                minutos.
                              </div>
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {user.id !== userLocal.id ? (
                      <div
                        className={`${style.subContComentario} ${
                          !displayNone ? style.displayNone : ""
                        }`}
                      >
                        {scoreMetricas.entrenamiento === null ? (
                          <div className={style.contComentario}>
                            <p className={style.comentario}>Sin comentarios.</p>
                            <p className={style.comentario}>
                              {scoreMetricas.score?.comentario}
                            </p>
                          </div>
                        ) : (
                          <div className={style.ContenedorComentarios}>
                            <p className={style.comentario}>Comentarios:</p>
                            <div className={style.contComentario}>
                              {scoreMetricas.entrenamiento?.estrellas
                                ?.slice() // para no mutar el array original
                                .sort(
                                  (a, b) =>
                                    new Date(b.createdAt) -
                                    new Date(a.createdAt)
                                )
                                .map((comentario) => (
                                  <Comentarios
                                    key={comentario.id}
                                    id={comentario.id}
                                    usuario={comentario.usuario}
                                    fecha={comentario.createdAt}
                                    contenido={comentario.comentario}
                                    valor={comentario.valor}
                                    estrellasBool={true}
                                  />
                                ))}
                            </div>
                          </div>
                        )}
                        {scoreMetricas.entrenamiento !== null && userLocal.rol !== "Jugador" && userLocal.rol !== "Aficionado" ? (
                          <AgregarComentario
                            user={user}
                            mensaje={comentarioEstrellas}
                            setMensaje={setComentarioEstrellas}
                            postComentario={darEstrellas}
                            valor={valor}
                            setValor={setValor}
                            estrellasBool={true}
                            error={error}
                          />
                        ) : (
                          <div className={style.contComentario}>
                            <p className={style.comentario}>
                              No es posible agregar un comentario
                            </p>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className={style.subContComentario}>
                        {!scoreMetricas || !scoreMetricas.score ? (
                          <div className={style.contComentario}>
                            <p className={style.comentario}>
                              No es posible agregar un comentario
                            </p>
                          </div>
                        ) : (
                          <div className={style.comentarios}>
                            <p className={style.comentario}>Comentarios:</p>
                            <div className={style.contComentario}>
                              {scoreMetricas.entrenamiento?.estrellas
                                ?.slice() // para no mutar el array original
                                .sort(
                                  (a, b) =>
                                    new Date(b.createdAt) -
                                    new Date(a.createdAt)
                                )
                                .map((comentario) => (
                                  <Comentarios
                                    key={comentario.id}
                                    id={comentario.id}
                                    usuario={comentario.usuario}
                                    fecha={comentario.createdAt}
                                    contenido={comentario.comentario}
                                    valor={comentario.valor}
                                    estrellasBool={true}
                                  />
                                ))}
                            </div>
                            {scoreMetricas.entrenamiento !== null && userLocal.rol !== "Jugador" && userLocal.rol !== "Aficionado" ? (
                              <AgregarComentario
                                user={user}
                                mensaje={comentarioEstrellas}
                                setMensaje={setComentarioEstrellas}
                                postComentario={darEstrellas}
                                valor={valor}
                                setValor={setValor}
                                estrellasBool={true}
                                error={error}
                              />
                            ) : (
                              <div className={style.contComentario}>
                                <p className={style.comentario}>
                                  No es posible agregar un comentario
                                </p>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {mostrarVideo && (
                    <div className={style.contVideo}>
                      <VideoPlayer
                        width={600}
                        height={320}
                        video={scoreMetricas.entrenamiento?.video}
                        controls
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalScore;
